import styled from "@emotion/styled";
import { fontPlayfairDisplay, transientOptions } from "@product/scmp-sdk";

import { BaseImage } from "scmp-app/components/common/base-image";
import { Swiper } from "scmp-app/components/swiper";
import { setFullViewportWidthStyles } from "scmp-app/lib/styles";

import IconArrow from "./icon-arrow.svg?url";

export const StyledBaseImage = styled(BaseImage)``;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 35px;
  align-items: center;

  ${setFullViewportWidthStyles()}

  ${props => props.theme.breakpoints.up("tablet")} {
    row-gap: 64px;
  }
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  inline-size: 100%;

  ${props => props.theme.breakpoints.up("tablet")} {
    flex-direction: row;

    max-inline-size: 1344px;
  }
`;

type StyledSwiperProps = {
  $center?: boolean;
};
export const StyledSwiper = styled(Swiper, { ...transientOptions })<StyledSwiperProps>`
  &.swiper {
    inline-size: 100%;
    ${props => props.theme.breakpoints.up("tablet")} {
      display: flex;

      padding-inline: 28px;
    }
    ${props => props.theme.breakpoints.up("desktop")} {
      padding-inline: 40px;
    }
  }

  & {
    .swiper-button-prev,
    .swiper-button-next {
      inset-block-start: calc(50% - 40px);
      inset-inline-end: 0;

      inline-size: 80px;
      block-size: 80px;

      background-image: url(${IconArrow});
      background-size: cover;

      transform: translate(0, -50%);

      &.swiper-button-prev {
        inset-inline-start: 0;

        transform: scaleX(-1) translate(0, -50%);
      }

      ${props => props.theme.breakpoints.up("tablet")} {
        opacity: 1;

        &.swiper-button-disabled {
          display: none;
        }
      }
    }

    .swiper-wrapper {
      justify-content: ${props => (props.$center ? "center" : "flex-start")};

      inline-size: 100%;
      ${props => props.theme.breakpoints.down("tablet")} {
        display: flex;
        flex-direction: column;

        .swiper-slide {
          margin-block-end: 32px;
        }
      }
    }
  }
`;

export const Title = styled.div`
  color: #222222;
  font-size: 32px;
  font-family: ${fontPlayfairDisplay};
  line-height: 32px;
  letter-spacing: -1.28px;

  ${props => props.theme.breakpoints.up("tablet")} {
    font-size: 48px;
    line-height: 48px;
    letter-spacing: -1.44px;
  }

  span {
    font-style: italic;
  }
`;
